import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "components/Modal";

/** 발급 제한 국가 고객의 카드 신청 차단 안내 팝업 */
const CardApplyBlockModal: React.FC<CardApplyBlockProps> = (props) => {
  /** 다국어처리 */
  const { t } = useTranslation();

  return (
    <Modal isOpen={props.isOpen} onRequestClose={props.onClose} contentLabel="modal" className="popTyLayer2" overlayClassName="dim" closeTimeoutMS={500}>
      <p className="message">{t("ERROR.restrictedCountry", "Card application is not available for your nationality.")}</p>
      <div className="btnWrapTy02">
        <button type="button" className="btnPrimaryTy01" onClick={props.onClose}><span>{t("COMMON.button.confirm")}</span></button>
      </div>
    </Modal>
  );
}

export default CardApplyBlockModal;
